import { render } from "./AddImages.vue?vue&type=template&id=6d11aa77&scoped=true"
import script from "./AddImages.vue?vue&type=script&lang=js"
export * from "./AddImages.vue?vue&type=script&lang=js"

import "./AddImages.vue?vue&type=style&index=0&id=6d11aa77&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d11aa77"]])

export default __exports__